import React from "react";

import Layout from "../components/layout";
import SEO from "../components/seo";
import Hero from "../components/landingPageComponents/hero";
// import PageSection from "../components/pageSection";
import LandingSection from "../components/landingPageComponents/landingSection";
import AreaServed from "../components/landingPageComponents/areaServed";
import LogoSection from "../components/landingPageComponents/logos";

function IndexPage() {
  return (
    <Layout>
      <SEO
        keywords={[`gatsby`, `tailwind`, `react`, `tailwindcss`]}
        title="Home"
      />

      <section className="text-center">
        <Hero />
        <LandingSection />
        <AreaServed />
        <LogoSection />
      </section>
    </Layout>
  );
}

export default IndexPage;
